import { Injectable } from '@angular/core';
import { ICostAccountingType } from '../models/cost-accounting-type.model';
import { CostAccountingRequestService } from '../services/cost-accounting-request.request.service';
import { Observable } from 'rxjs';

const BASE_URL: string = 'cost-accounting-type';

@Injectable({
    providedIn: 'root'
})
export class CostAccountingTypeResource {
    constructor(private myCostAccountingRequestService: CostAccountingRequestService) {
    }

    public getAllCostAccountingTypes(): Observable<ICostAccountingType[]> {
        return this.myCostAccountingRequestService.get(BASE_URL);
    }

    public addCostAccountingType(costAccountingType: ICostAccountingType): Observable<ICostAccountingType>{
        return this.myCostAccountingRequestService.post(BASE_URL, costAccountingType);
    }

    public deleteCostAccountingType(typeId: number): Observable<void> {
        return this.myCostAccountingRequestService.delete(`${BASE_URL}/${typeId}`);
    }
}
